import React from "react";
import { render } from "react-dom";

import { DragDropContextProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import TouchBackend from "react-dnd-touch-backend";
import { getDropTargetElementsAtPoint } from "./helpers/dragNDrop";
import { hasClientFeature } from "./helpers/client";

import { disableBodyScroll } from "body-scroll-lock";
import initReactFastclick from "react-fastclick";
import { Provider } from "react-redux";
import history from "./helpers/history";
import store from "./store";
import { Router, Route, Switch } from "react-router-dom";

import { unregister } from "./registerServiceWorker";
import { playAmbientSounds, checkMute, mute } from "./sounds";

import AppContainer from "./AppContainer";
import LoginContainer from "./components/Login/LoginContainer";

store.subscribe(checkMute);

// Browser events
window.addEventListener("blur", mute);
window.addEventListener("focus", checkMute);

// Cordova events
document.addEventListener("deviceready", () => {
  document.addEventListener("pause", mute);
  document.addEventListener("resume", checkMute);
});

playAmbientSounds();

const dragNDropBackend = hasClientFeature("touchevents")
  ? TouchBackend({
      touchSlop: 20,
      getDropTargetElementsAtPoint
    })
  : HTML5Backend;

const rootEl = document.getElementById("root");

disableBodyScroll(rootEl);

initReactFastclick();

render(
  <DragDropContextProvider backend={dragNDropBackend}>
    <Provider store={store}>
      <Router history={history}>
        <Switch>
          <Route path="/:lang(\w{2})?/login" component={LoginContainer} />
          <Route
            path="/:lang(\w{2})?/:seed(\d+)?/:level(\d+)?/:secret?"
            component={AppContainer}
          />
        </Switch>
      </Router>
    </Provider>
  </DragDropContextProvider>,
  rootEl
);

unregister();



// WEBPACK FOOTER //
// ./src/index.js